import React from 'react';
import { Router, Switch, Route } from 'react-router-dom';
import browserHistory from './browser-history';
import { Atlas } from './pages/atlas';
import { LegacyAtlasServer } from './pages/legacy-atlas-server';
import { ContactSales } from './pages/contact-sales';
import { PageNotFound } from './pages/404';
import { store } from './redux/store';
import { userLoaded } from './redux/action-creators';

export default class App extends React.Component {
  componentDidMount() {
    store.dispatch(userLoaded(this.props.user));
  }
  render() {
    return (
      <Router history={browserHistory}>
        <Switch>
          <Route path="/" exact={true} component={Atlas} />
          <Route path="/atlas-server" component={LegacyAtlasServer} />
          <Route path="/contact-sales" component={ContactSales} />
          <Route path="*" component={PageNotFound} />
        </Switch>
      </Router>
    );
  }
}
